import React from 'react';
import clsx from 'clsx';
import Depot from '../../../_shared/depot';
import * as styles from './style.module.css';
const SelectWithoutRef = ({ items, placeholder, className, value, errorMessage, ...commonProps }) => {
    // Classes
    const selectClasses = clsx(className, styles.select, {
        [styles.placeholder]: placeholder && value === '',
        [styles.error]: errorMessage,
    });
    return Depot.createElement('select', {
        value,
        className: selectClasses,
        ...commonProps,
    }, React.createElement(React.Fragment, null,
        placeholder && (React.createElement("option", { value: "", key: "placeholder", disabled: true }, placeholder)),
        items.map(({ text, ...optionProps }, index) => {
            return (React.createElement("option", { key: index, ...optionProps, "aria-disabled": !!(optionProps === null || optionProps === void 0 ? void 0 : optionProps.disabled), "aria-selected": !!(value === optionProps.value) }, text));
        })));
};
const Select = Depot.withRef(SelectWithoutRef);
Select.displayName = 'Select';
export default Select;
//# sourceMappingURL=index.js.map